export const REG_EX_NUMERIC = /^[0-9]+$/ ;
export const ANNUAL_AVG_LIMIT = 25000;
export const EMPLOYEE_TO_HOUR_RATIO = 8760;
export const EMPLOYEE_TO_HOUR_LOW_RATIO = 500;


/** WEBPACK FOOTER **
 ** ./src/constants/injurySummaryEditConstants.js
 **/